module.exports = __webpack_public_path__ + "static/media/EPS.4599dae4.svg";